


import { XMarkIcon } from '@heroicons/react/24/solid'
import { useState, useEffect, useCallback } from 'react';
import Arquivos from '../Arquivos'
import Arquivo from '../Arquivo'


const Config = ({ data, upload}) => {

    const [errors, setErrors] = useState({
        corPrimaria: false,
        corSecundaria: false,
        corTerciaria: false,
        email: false,
        whatsapp: false,
        facebook: false,
        instagram: false

    })
    const [objHome, setObjHome] = useState({})

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            setObjHome(data)

        }
    }, [data])


    const [files, setFiles] = useState([])
    const [fileSecao2, setFileSecao2] = useState([])
    const [isEdit, setIsEdit] = useState(false);

    const isValidHex = (hex) => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex);



    const [originalImages, setOriginalImages] = useState([]);
    const [newImages, setNewImages] = useState([]);
    const [removedImages, setRemovedImages] = useState([]);
    const [isDragOver, setIsDragOver] = useState(false);
    const [error, setError] = useState(false);

    const onDragEnter = () => setIsDragOver(true);
    const onDragLeave = () => setIsDragOver(false);

    const [idSecao, setIdSecao] = useState(0)

    // Carregar imagens iniciais do banco de dados
    useEffect(() => {
        if (data.secao4?.img) {
            setOriginalImages(data.secao4.img);
            setNewImages([]);
            setRemovedImages([]);
            setIdSecao(data.id)
        }
    }, [data]);


    const imageSpaces = () => {
        const allImages = [...originalImages, ...newImages];
        const placeholders = 4 - allImages.length; // Calcula quantos placeholders são necessários

        return (
            <>
                {allImages.map((image, index) => (
                    <div key={index} className="relative">
                        <img
                            src={image instanceof File ? URL.createObjectURL(image) : image.url}
                            alt={`Preview ${index}`}
                            className="h-24 w-full rounded-md object-cover"
                            crossOrigin='anonymous'
                        />
                        <XMarkIcon
                            onClick={() => handleRemoveFile(image, index)}
                            className="absolute top-0 right-0 h-5 w-5 text-red-500 cursor-pointer"
                            aria-hidden="true"
                        />
                    </div>
                ))}
                {Array.from({ length: placeholders }).map((_, index) => (
                    <div key={`placeholder-${index}`} className="h-24 w-full rounded-md object-cover border-2 border-dashed border-gray-300 flex justify-center items-center">
                        {/* Aqui você pode colocar um ícone ou texto indicando que é um placeholder */}
                        <p className="text-gray-500">Adicionar Imagem</p>
                    </div>
                ))}
            </>
        );
    };


    const onDrop = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation(); //

        // Extrair arquivos do evento de drop
        const droppedFiles = event.dataTransfer ? event.dataTransfer.files : event.target.files;

        // Calcular o número total de imagens após adicionar as novas
        const totalImages = originalImages.length + newImages.length + droppedFiles.length;

        if (totalImages > 4) {
            setError('Pode ter no máximo 4 arquivos adicionados');
        } else {
            // Adicionar novos arquivos à lista de novas imagens
            setNewImages([...newImages, ...Array.from(droppedFiles)]);
        }
    }, [originalImages, newImages]);





    const onDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation(); //
    };

    // // console.log(data.secao3?.numbers[0]?.texto.description)

    // Estados para imagens originais, novas e removidas


    // Atualizar a lista de novas imagens
    const onFileChange = (event) => {
        const totalImages = originalImages.length + newImages.length + event.target.files.length;
        if (totalImages > 4) {
            setError('Pode ter no máximo 4 arquivos adicionados');
        } else {
            // Adicionar novos arquivos à lista de novas imagens
            setNewImages([...newImages, ...Array.from(event.target.files)]);
        }
    };

    // Remover uma imagem
    const handleRemoveFile = (image, index) => {
        if (originalImages.length == 1 && newImages.length == 0) {
            setError('Deve ter pelo menos uma imagem')
            return
        }
        if (originalImages.includes(image)) {
            if (removedImages.length == 0) {
                setRemovedImages([image]);
            } else {
                setRemovedImages([...removedImages, image]);
            }
            setOriginalImages(originalImages.filter((_, idx) => idx !== index));
        } else {
            setNewImages(newImages.filter((_, idx) => idx !== index));
        }
    };
    // // console.log(data.secao4?.icons[0]?.texto.description)

    const onSubmit = async (e) => {
        e.preventDefault();
        //AQUI DEVE PERMITIR CASO SEJA SOMENTE TEXTO
        // if (newImages.length == 0 && removedImages.length == 0) {
        //     setError('Não ocorreu nenhuma alteração nas imagens')
        //     return
        // }
        if ((newImages.length + originalImages.length) != 4) {
            setError('Pode ter no máximo 4 arquivos adicionados')
            return
        }else{
            setError('')
        }
        //DEVE TER EXATAMENTE 4 SELECIONADOS -> SEMPRE 
        const updatedImages = {
            id: idSecao,
            added: newImages,
            removed: removedImages,
            kept: originalImages,
            secao4: {
                titulo: { ...objHome.secao4?.titulo, titulo: objHome.secao4?.titulo?.titulo },
                texto: { ...objHome.secao4?.texto, description: objHome.secao4?.texto?.description },
                subtitulo: { ...objHome.secao4?.subtitulo, description: objHome.secao4?.subtitulo?.description },
                icons: objHome.secao4?.icons
            }
        };
        const formData = new FormData();
        // formData.append('id', idSecao)
        newImages.forEach((file) => {
            formData.append('images', file); // 'file' é um objeto File
        });

        // Adicionando IDs das imagens removidas
        formData.append('removed', JSON.stringify(removedImages)); // Supondo que 'image' tem um 'id'

        formData.append('secao4', JSON.stringify(updatedImages.secao4))

        // Adicionando IDs das imagens mantidas
        originalImages.forEach((image) => {
            formData.append('kept', image.id); // Da mesma forma aqui
        });


        await upload(formData, idSecao)

    };

    return (
        <form className='flex w-full flex-col' onSubmit={onSubmit}>
            <div className="space-y-12">
                <div className="border-b border-gray-900/10 pb-12">
                    {/* INICIO DE ARQUIVOS */}
                    <div className="col-span-6">
                        <h1 htmlFor="cover-photo" className="block text-sm  leading-6 text-gray-900">
                            ICONES
                        </h1>
                        <div className="mt-2 flex justify-center w-[100%]">
                            <div className="mt-2 grid grid-cols-4 gap-4  ">
                                {imageSpaces()}
                            </div>
                        </div>

                        {
                            newImages.length > 0 && (
                                <div className="mt-2 flex items-center gap-x-3">
                                    <div className="flex flex-col gap-y-2">
                                        <div className="flex items-center gap-x-2">
                                            <span className="text-sm font-medium leading-6 text-gray-900">
                                                {newImages[0].name}
                                            </span>
                                            <XMarkIcon onClick={() => setFiles([])} className="h-5 w-5 text-red-500 cursor-pointer" aria-hidden="true" />
                                        </div>
                                        <span className="text-sm leading-6 text-gray-500">
                                            {newImages[0].size} bytes
                                        </span>
                                    </div>
                                </div>
                            )
                        }

                        {
                            error != '' && <p className="text-red-500 text-xs mt-1">{error}</p>
                        }
                        <div className={`text-center ${isDragOver ? 'border-indigo-600' : 'border-gray-900/25'} mt-2 flex justify-center rounded-lg border border-dashed px-6 py-10`}
                            onDrop={onDrop} onDragOver={onDragOver} onDragEnter={onDragEnter}
                            onDragLeave={onDragLeave}>
                            <div className="mt-4 flex text-sm text-center leading-6 text-gray-600">
                                <label
                                    htmlFor="file-upload"
                                    className="relative cursor-pointer  rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                >
                                    <span>Upload a file</span>
                                    <input id="file-upload" name="file-upload" type="file" className="sr-only" onChange={onFileChange} />
                                </label>
                                <p className="pl-1">or drag and drop</p>
                            </div>
                            <p className="text-xs leading-5 text-gray-600">PNG, JPG up to 10MB</p>

                        </div>
                    </div>
                    {/* FIM DE ARQUIVOS */}

                    {/* SECAO 04 */}
                    <div className='border rounded-[10px] mt-2 p-4'>
                        <h1 className="text-lg font-semibold leading-6 text-gray-900">Seleção do cabeçalho da seção</h1>

                        <div className="mt-6 border p-2 rounded-[10px]">
                            <label htmlFor="about" className="block text-sm font-medium text-gray-900">
                                Título centralizado:
                            </label>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    name="link"
                                    maxLength={80}
                                    id="link"
                                    value={objHome.secao4?.titulo?.titulo}
                                    onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, titulo: { titulo: e.target.value } } })}
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                        <div className="mt-6 p-2 rounded-[10px] border">
                            <label htmlFor="about" className="block text-sm font-medium text-gray-900">
                                Texto:
                            </label>
                            <div className="mt-1">
                                <textarea
                                    type="text"
                                    name="texto"
                                    maxLength={200}
                                    id="texto"
                                    value={objHome.secao4?.texto?.description}
                                    onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, texto: { description: e.target.value } } })}
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                />
                            </div>
                        </div>
                        <div className="mt-6 p-2 rounded-[10px] border">
                            <label htmlFor="about" className="block text-sm font-medium text-gray-900">
                                Subtitulo:
                            </label>
                            <div className="mt-1">
                                <input
                                    type="text"
                                    maxLength={200}
                                    name="subtitulo"
                                    id="subtitulo"
                                    value={objHome.secao4?.subtitulo?.description}
                                    onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, subtitulo: { description: e.target.value } } })}
                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                />
                            </div>
                        </div>

                    </div>

                    <div className='border rounded-[10px] mt-4 p-4'>
                        <h1 className="text-lg font-semibold leading-6 text-gray-900">Seleção do título e descrição do ícone</h1>
                        <div className='mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6'>


                            <div className='col-span-3'>
                                <div>
                                    <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Título  do ícone #1
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[0].titulo.titulo}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [{ ...objHome.secao4?.icons[0], titulo: { ...objHome.secao4?.icons[0].titulo, titulo: e.target.value } }, objHome.secao4?.icons[1], objHome.secao4?.icons[2], objHome.secao4?.icons[3]] } })}
                                            type="text"
                                            placeholder='50'
                                            name="first-name"
                                            id="first-name"
                                            autoComplete="given-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Descrição do ícone #1
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[0]?.texto.description}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [{ ...objHome.secao4?.icons[0], texto: { ...objHome.secao4?.icons[0].texto, description: e.target.value } }, objHome.secao4?.icons[1], objHome.secao4?.icons[2], objHome.secao4?.icons[3]] } })}

                                            type="text"
                                            name="last-name"
                                            placeholder='Ranking no Google'
                                            id="last-name"
                                            autoComplete="family-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                            </div>


                            <div className='col-span-3'>
                                <div>
                                    <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Título  do ícone #2
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[1]?.titulo.titulo}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [objHome.secao4?.icons[0], { ...objHome.secao4?.icons[1], titulo: { ...objHome.secao4?.icons[1].titulo, titulo: e.target.value } }, objHome.secao4?.icons[2], objHome.secao4?.icons[3]] } })}

                                            type="text"
                                            placeholder='50'
                                            name="first-name"
                                            id="first-name"
                                            autoComplete="given-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Descrição do ícone #2
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[1]?.texto.description}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [objHome.secao4?.icons[0], { ...objHome.secao4?.icons[1], texto: { ...objHome.secao4?.icons[1].texto, description: e.target.value } }, objHome.secao4?.icons[2], objHome.secao4?.icons[3]] } })}
                                            type="text"
                                            name="last-name"
                                            placeholder='Ranking no Google'
                                            id="last-name"
                                            autoComplete="family-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className='col-span-3'>
                                <div>
                                    <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Título  do ícone #3
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[2]?.titulo.titulo}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [objHome.secao4?.icons[0], objHome.secao4?.icons[1], { ...objHome.secao4?.icons[2], titulo: { ...objHome.secao4?.icons[2]?.titulo, titulo: e.target.value } }, objHome.secao4?.icons[3]] } })}
                                            type="text"
                                            placeholder='50'
                                            name="first-name"
                                            id="first-name"
                                            autoComplete="given-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Descrição do ícone #3
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[2]?.texto.description}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [objHome.secao4?.icons[0], objHome.secao4?.icons[1], { ...objHome.secao4?.icons[2], texto: { ...objHome.secao4?.icons[2]?.texto, description: e.target.value } }, objHome.secao4?.icons[3]] } })}
                                            type="text"
                                            name="last-name"
                                            placeholder='Ranking no Google'
                                            id="last-name"
                                            autoComplete="family-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                            </div>


                            <div className='col-span-3'>
                                <div>
                                    <label htmlFor="first-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Título  do ícone #4
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[3]?.titulo.titulo}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [objHome.secao4?.icons[0], objHome.secao4?.icons[1], objHome.secao4?.icons[2], { ...objHome.secao4?.icons[3], titulo: { ...objHome.secao4?.icons[3]?.titulo, titulo: e.target.value } }] } })}
                                            type="text"
                                            placeholder='50'
                                            name="first-name"
                                            id="first-name"
                                            autoComplete="given-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label htmlFor="last-name" className="block text-sm font-semibold leading-6 text-gray-900">
                                        Descrição do ícone #4
                                    </label>
                                    <div className="mt-2.5">
                                        <input
                                            value={objHome.secao4?.icons[3]?.texto.description}
                                            onChange={(e) => setObjHome({ ...objHome, secao4: { ...objHome.secao4, icons: [objHome.secao4?.icons[0], objHome.secao4?.icons[1], objHome.secao4?.icons[2], { ...objHome.secao4?.icons[3], texto: { ...objHome.secao4?.icons[3]?.texto, description: e.target.value } }] } })}
                                            type="text"
                                            name="last-name"
                                            placeholder='Ranking no Google'
                                            id="last-name"
                                            autoComplete="family-name"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                            </div>



                        </div>

                    </div>
                    {/* FIM DA SECAO 4 */}











                </div>
            </div>

            <div className="mt-6 flex items-center justify-end gap-x-6">
                <button type="button" className="text-sm font-semibold leading-6 text-gray-900">
                    Cancel
                </button>
                <button
                    type="submit"
                    className="rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                >
                    {
                        Object.keys(data).length > 0 ? 'Atualizar' : 'Salvar'
                    }
                </button>
            </div>
        </form >
    )


}



export default Config;
